import React, { FC, useContext } from 'react';
import { makeStyles, tokens } from '@fluentui/react-components';
import { I18nContext } from '@bingads-webui/copilot-i18n';
import type { I18nModel } from './types';

const useFooterStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: tokens.spacingVerticalS,
    paddingBottom: tokens.spacingVerticalS,
    paddingLeft: tokens.spacingHorizontalM,
    paddingRight: tokens.spacingHorizontalM,
  },
  absolute: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
  },
  placeholder: {
    // Maintains space when footer is positioned absolutely
    height: '20px', // Approximate height of footer
  },
  text: {
    fontSize: tokens.fontSizeBase200,
    margin: 0,
    textAlign: 'center',
    color: tokens.colorNeutralForeground3,
  },
});

export interface IFooterProps {
  className?: string;
  conversationHasMessages?: boolean;
  disclaimerText?: string;
}

export const Footer: FC<IFooterProps> = ({
  className,
  conversationHasMessages = false,
  disclaimerText,
}) => {
  const styles = useFooterStyles();
  const i18n = useContext(I18nContext) as I18nModel;

  return (
    <>
      <div className={styles.placeholder} >
        <div className={`${styles.root} ${conversationHasMessages ? styles.absolute : 'hidden'} ${className || ''}`}>
          <p className={styles.text}>
            {i18n?.getString(disclaimerText || _TL_('Copilot uses AI. Check for mistakes.'))}
          </p>
        </div>
      </div>
    </>
  );
};
